import React from 'react';

/**
 * Container component for consistent layout across the site
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactElement} Container component
 */
const Container = ({ children, className = '' }) => {
  return (
    <div className={`max-w-7xl mx-auto px-6 md:px-10 ${className}`}>
      {children}
    </div>
  );
};

export default Container;
